import { render, staticRenderFns } from "./kim-main.vue?vue&type=template&id=27c1bd6b&scoped=true&"
import script from "./kim-main.vue?vue&type=script&lang=js&"
export * from "./kim-main.vue?vue&type=script&lang=js&"
import style0 from "./kim-main.vue?vue&type=style&index=0&id=27c1bd6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c1bd6b",
  null
  
)

export default component.exports